/* eslint-disable react/prop-types */
import React from 'react';

import PropTypes from 'prop-types';
import styled from 'styled-components';

const OrderCodeStyled = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  min-width: 100px;
`;

const Code = styled.span`
  text-align: left;
  font: normal normal 600 18px/18px Source Sans Pro;
  letter-spacing: 0px;
  color: #424242;
`;

const StoreName = styled.span`
  text-align: left;
  font: normal normal normal 18px/18px Source Sans Pro;
  letter-spacing: 0px;
  color: #424242;
`;

export function OrderCode({ code, storeName }) {
  return (
    <OrderCodeStyled>
      <Code>{code}</Code>
      <StoreName>{storeName}</StoreName>
    </OrderCodeStyled>
  );
}

OrderCode.prototype = {
  code: PropTypes.string.isRequired,
  storeName: PropTypes.string.isRequired,
};
